import type { ServiceStatus } from '@/types';

import { cn } from '@/lib/utils';
import { INTERFACE_STATUS_DOT } from '@/utils/constants';

interface StatusIndicatorProps {
  status: ServiceStatus;
  className?: string;
}

const StatusIndicator = ({ status, className }: StatusIndicatorProps) => (
  <span
    aria-hidden
    className={cn('inline-block shrink-0 rounded-full', INTERFACE_STATUS_DOT[status], className)}
  />
);

export default StatusIndicator;
